export default {
  path: 'settings/tags-configuration',
  name: 'RoadMaintenanceTagsConfiguration',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/TagsConfigurationIndex.vue')
}
